import styled from 'styled-components'

const Link = styled.a`
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.6px;
  color: inherit;

  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`

export default Link
